import { render } from "./Header.vue?vue&type=template&id=2049c989&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2049c989&lang=scss&scoped=true"

import exportComponent from "/Users/christianwidodo/workspace_git/lionsgate/tuwomt/cagespace-site/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2049c989"]])

export default __exports__